<template>

      <div class="title">
        {{$t('library.steps.info.name')}}
      </div>
      <div class="p-mb-5 p-mt-2 irinox-form">
        <InputText type="text" :value="name" @input="nameChanged($event.target.value)"
          :placeholder="$t('library.steps.info.name_ph')" :aria-label="$t('library.steps.info.name')"/>
      </div>

      <div class="title">
        {{$t('library.steps.info.description')}}
      </div>
      <div class="p-mb-5 p-mt-2 irinox-form">
        <Textarea :value="description" :autoResize="true" rows="5" cols="30" @input="descriptionChanged($event.target.value)" 
          :placeholder="$t('library.steps.info.description_ph')" :aria-label="$t('library.steps.info.description')"/>
      </div>
      
</template>

<script>
export default {
  emits: ['update:name','update:description','update:headerButtonHidden'],
  components: {
    },
    props: {
      name: String,
      description: String
    },
    data() {
        return {
        };
    },
    computed: {
    },
    created() {
    },
    mounted() {
      this.validation();
    },
    watch: {
      name: 'validation',
      description: 'validation',
    },
    methods: {
      validation() {
        this.$emit("update:headerButtonHidden", !(this.name && this.description) );
      },
      nameChanged(newName) {
        this.$emit("update:name", { name: newName });
      },
      descriptionChanged(newDescription) {
        this.$emit("update:description", { description: newDescription });
      },
    }

}
</script>

<style scoped>
</style>